import {AlertScheduleManager} from "./AlertScheduleManager";
import {
  AAF_MODAL_DEVICE_CHANGE_KAON,
  HIDE_MODAL, showModal
} from "../../../../actions/modal";
import store from "../../../../store";
import Metadata from "../../../../requests/apa/Metadata";
import DataStorage from "../../../DeviceStorage/LocalStorage";
import AAFPlayer from "../../../../AAFPlayer/AAFPlayer";

const isPlaying = () => {
  const {playerstate = null, source = {} } = store.getState().player || {};
  const idVideo = source.videoid || null;

  return playerstate && playerstate === "PLAYING" && idVideo && idVideo !== "";
};

const getConfig = () => {
  const data = Metadata.get("upgrade_device_alert",
    `{"default": {"enable": false}}`)

  try {
    const region = DataStorage.getItem('region') || 'default';
    const configData = JSON.parse(data);

    return configData[region] || configData['default'] || {enable: false};
  } catch (e) {
    return {enable: false};
  }
};

export const reviewAlertScheduleManager = (callback, channelToPlay, params) => {
  const config = getConfig()
  const alertManager = AlertScheduleManager.getInstance();

  alertManager
    .init(config)
    .setOnShowModal(function (data) {
      const userIsPlaying = isPlaying();

      store.dispatch(showModal({
        modalType: AAF_MODAL_DEVICE_CHANGE_KAON,
        modalProps: {}
      }))
      userIsPlaying && AAFPlayer.pause()
    })
    .setOnHideModal(function (data) {
      const userIsPlaying = isPlaying();

      store.dispatch(showModal({
        modalType: HIDE_MODAL,
        modalProps: {}
      }))
      userIsPlaying && AAFPlayer.resume()
      data.joinedInProgress && callback && callback(channelToPlay, params);
    })
    .start(1000);
};



// WEBPACK FOOTER //
// ./src/components/Modal/functions/AAFModalDeviceChangeKaon/utils.js